import { render, staticRenderFns } from "./azulCargo.vue?vue&type=template&id=a19dc7a8"
import script from "./azulCargo.ts?vue&type=script&lang=js&external"
export * from "./azulCargo.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a19dc7a8')) {
      api.createRecord('a19dc7a8', component.options)
    } else {
      api.reload('a19dc7a8', component.options)
    }
    module.hot.accept("./azulCargo.vue?vue&type=template&id=a19dc7a8", function () {
      api.rerender('a19dc7a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/expedicao/azulCargo.vue"
export default component.exports